<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 16 15" style="enable-background:new 0 0 21 21;" xml:space="preserve"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
<g>
	<path d="M1.9243164,4.20541V2.252773c0-0.090332,0.03125-0.1669922,0.0947266-0.230957
		C2.0825195,1.9588279,2.1591797,1.9270896,2.25,1.9270896h11.5004883c0.0908203,0,0.1669922,0.0317383,0.2304688,0.0947264
		c0.0634766,0.0639648,0.0947266,0.140625,0.0947266,0.230957V4.20541c0,0.0908203-0.03125,0.1674805-0.0947266,0.2304688
		c-0.0634766,0.0639648-0.1396484,0.0952148-0.2304688,0.0952148h-0.2167969c-0.0908203,0-0.1669922-0.03125-0.2304688-0.0952148
		c-0.0634766-0.0629883-0.0947266-0.1396484-0.0947266-0.2304688V2.7952535H8.4614258v6.9433594h1.1660156
		c0.0908203,0,0.1669922,0.0322266,0.2314453,0.0947266c0.0625,0.0634766,0.0947266,0.140625,0.0947266,0.2304688v0.2177734
		c0,0.0898438-0.0322266,0.1669922-0.0947266,0.2304688c-0.0644531,0.0634766-0.140625,0.0947266-0.2314453,0.0947266H6.3725586
		c-0.090332,0-0.1674805-0.03125-0.2304688-0.0947266c-0.0634766-0.0634766-0.0947266-0.140625-0.0947266-0.2304688v-0.2177734
		c0-0.0898438,0.03125-0.1669922,0.0947266-0.2304688c0.0629883-0.0625,0.1401367-0.0947266,0.2304688-0.0947266h1.1665039
		V2.7952535h-4.746582V4.20541c0,0.0908203-0.0317383,0.1674805-0.0952148,0.2304688
		C2.6337891,4.4998436,2.5571289,4.5310936,2.4667969,4.5310936H2.25c-0.0908203,0-0.1674805-0.03125-0.230957-0.0952148
		C1.9555664,4.3728905,1.9243164,4.2962303,1.9243164,4.20541z M13.9946289,12.6136131l-1.3017578-1.0849609
		c-0.0722656-0.0537109-0.1494141-0.0625-0.2304688-0.0273438c-0.0810547,0.0371094-0.1220703,0.0996094-0.1220703,0.1904297
		v0.6503906H3.6601562v-0.6503906c0-0.0908203-0.0405273-0.1533203-0.1220703-0.1904297
		c-0.0810547-0.0351562-0.1582031-0.0263672-0.2304688,0.0273438l-1.3017578,1.0849609
		c-0.0541992,0.0371094-0.081543,0.0908203-0.081543,0.1630859s0.0273438,0.1269531,0.081543,0.1621094l1.3017578,1.0859375
		c0.0722656,0.0537109,0.1494141,0.0625,0.2304688,0.0263672c0.081543-0.0361328,0.1220703-0.0996094,0.1220703-0.1894531
		v-0.6513672h8.6801758V13.86166c0,0.0898438,0.0410156,0.1533203,0.1220703,0.1894531s0.1582031,0.0273438,0.2304688-0.0263672
		l1.3017578-1.0859375c0.0546875-0.0351562,0.0810547-0.0898438,0.0810547-0.1621094S14.0493164,12.6507225,13.9946289,12.6136131z"
    />
</g>
</svg>
</template>

<script>
    export default {
        name: "TextIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
